import React, { PureComponent } from 'react'
import Moment from 'moment'
import ReactDOM from 'react-dom'
import { connect } from 'react-redux'
import { dealerSetAction, bookingSetAction, selectedServices, CurrentStepSetAction } from '../../actions/action'
import {
  Redirect,
} from 'react-router-dom'
import loadingIconAP from '../../images/AP/ap-loading.svg'
import loadingIconAC from '../../images/AC/ac-loading.svg'
import loadingIconDS from '../../images/DS/ds-loading.svg'
import loadingIconOV from '../../images/OV/ov-loading.svg'
import CONSTANTS from '../../constants'
import { slugify } from '../../helpers/functions'

const mapStateToProps = state => state
const mapDispatchToProps = { dealerSetAction, selectedServices, bookingSetAction, CurrentStepSetAction }

class TimeLineCalendar extends PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      timeLineData: [],
      selectedDate: new Date(),
      isTimeLineDataReady: false,
      goToNextStep: false,
      timestamps: ""
    }
    this.getTimeAndRedirect = this.getTimeAndRedirect.bind(this)
  }

  componentDidMount() {
    this.setState({
      timeLineData: [],
      selectedDate: new Date(),
      isTimeLineDataReady: this.props.isTimeLineDataReady
    })
  }

  componentWillReceiveProps(nextProps) {
    if (typeof this.porps != undefined) {
      this.setState({
        timeLineData: nextProps.data,
        selectedDate: nextProps.mounthNumber,
        isTimeLineDataReady: nextProps.isTimeLineDataReady

      })
    }
  }

  componentWillUpdate(nextProps, nextState) {
    if (nextState.goToNextStep) { this.setState({ goToNextStep: false }) }
  }

  getTimeAndRedirect(data) {
    const timestamps = Moment(data.dayDate + ' ' + data.time, 'D/M/Y HH:mm').format('X')
    this.setState({ timestamps: timestamps })
    const d = ReactDOM.findDOMNode(this.refs[data.keyDay + '-' + data.keyHours])
    for (let i = 0; i < document.querySelectorAll('.item-time').length; i++) {
      document.querySelectorAll('.item-time')[i].classList.remove('selected')
    }
    d.classList.add('selected')
    // if dealer changed then erase selected services in "vos besoins"
    if (this.props.dealerID !== this.props.store.dealer.iD) {
      console.warn('TimeLineCalendar:55 dealer changed :' + this.props.dealerID + ' /\ ' + this.props.store.dealer.iD)
      const SelectedServices = Object.assign({}, this.props.store.SelectedServices)
      const dataUpdatedWithSelectedForfaits = Object.values(SelectedServices).map(function (forfaitFamily, key) {
        forfaitFamily.forfaits = []
        return forfaitFamily
      })

      this.props.selectedServices(dataUpdatedWithSelectedForfaits)
    }
    /* window.location.replace( window.siteConfig.rootPath+'/'+window.siteConfig.language+'/intervention/'+data.dealerID+'?time='+timestamps); */
    this.setState({ goToNextStep: true })
    this.props.bookingSetAction({
      hour: data.time,
      date: data.dayDate,
      happy: (data.happyHour == 'false' ? false : Number(data.happyHour.substring(0, data.happyHour.length - 1)))
    })
    this.props.dealerSetAction({
      iD: this.props.dealerID,
      geoID: this.props.dealerGeoId,
      name: this.props.dealerName,
      adress: this.props.dealerAdress,
      city: this.props.dealerCity,
      zip: this.props.dealerZipCode,
      LCV: this.props.dealerLCV,
      PC: this.props.dealerPC,
      position: this.props.position,
      SelfReception: this.props.SelfReception,
      ListeIdSP: this.props.dealerPremServices
    })
    if (!!parseInt(CONSTANTS.SITE_INFO.ACTIVATENEWAPPOINTMENTJOURNEY)) {
      this.props.CurrentStepSetAction(3)
    }
  }
  handleTimeChoice = (day, keyDay, hour, keyHours) => {

    hour.time !== 'false' &&
      this.getTimeAndRedirect({
        dayDate: day.dayDate,
        time: hour.time,
        keyHours: keyHours,
        keyDay: keyDay,
        dealerID: this.props.dealerID,
        happyHour: hour.isHappy
      })

  }
  handleKeyDown = (event, day, keyDay, hour, keyHours) => {
    if (event.key === 'Enter') {
      hour.time !== 'false' &&
        this.getTimeAndRedirect({
          dayDate: day.dayDate,
          time: hour.time,
          keyHours: keyHours,
          keyDay: keyDay,
          dealerID: this.props.dealerID,
          happyHour: hour.isHappy
        })
    }

  }

  render() {
    const ActivatePaP = (!!parseInt(CONSTANTS.SITE_INFO.ACTIVATENEWAPPOINTMENTJOURNEY))
    return (
      <>
        {this.state.goToNextStep && ActivatePaP &&
          <Redirect
            key='from-timeLine'
            from={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${slugify(this.props.dealerCity) + '/' + slugify(this.props.dealerName) + '/' + this.props.dealerGeoId}`}
            to={{ pathname: `${CONSTANTS.SITE_ROUTS.CARDETECTIONPAGE}` }}
          />}

        {this.state.goToNextStep && !ActivatePaP &&
          <Redirect
            key='from-timeLine'
            from={`${CONSTANTS.SITE_ROUTS.SOLODEALERPAGE}${slugify(this.props.dealerCity) + '/' + slugify(this.props.dealerName) + '/' + this.props.dealerGeoId}`}
            to={{ pathname: window.location.replace(window.siteConfig.rootPath + '/' + window.siteConfig.language + '/' + window.siteConfig.interventionLink + '/' + this.props.dealerGeoId + '?time=' + this.state.timestamps) }}
          />}


        <div className={'dealer-callendar half-block ' +
          (this.state.timeLineData.length < 1 ||
            typeof (this.state.timeLineData[0]) !== 'undefined' &&
            this.state.timeLineData[0].hours.length < 1
            ? 'dealer-unavailable' : '')}
        >
          <div className='callendar-header'>
            <button
              className={'header-arrows arrow-left' + (Moment(this.state.selectedDate).isSameOrBefore(new Date()) ? ' disabledArrow' : '')}
              onClick={this.props.headerArrowWeek.bind(this, this.state.selectedDate, 'prev')}
            />
            <div className='header-content'>

              <div className='header-mounth--title'>
                <span>{Moment().month(new Date(this.state.selectedDate).getMonth()).format('MMMM')}</span>{" "}
                {CONSTANTS.SITE_INFO.BRAND_CODE === "C" && <span>{Moment().year(new Date(this.state.selectedDate).getFullYear()).format('YYYY')}</span>}
              </div>
              <div className='header-mounths'>
                <ul className='header-mounth--list'>

                  {this.state.timeLineData.length > 0 && this.state.timeLineData.map(function (day, key) {
                    if (key < 4) {
                      return (
                        <li className='header-mounth--item' key={key}>
                          <span className='mounth--name'>{Moment(day.dayDate, 'D/M/Y').format('ddd')}</span>
                          <span className='mounth--number'> {Moment(day.dayDate, 'D/M/Y').format('D')}</span>
                        </li>
                      )
                    }
                  })}

                </ul>
              </div>
            </div>
            <button className='header-arrows arrow-right' onClick={this.props.headerArrowWeek.bind(this, this.state.selectedDate, 'next')} />
          </div>
          {(this.state.isTimeLineDataReady
            ? <div className='callendar-body' ref={this.props.calendarBodyElement}>
              {(this.state.timeLineData.length > 0 &&
                typeof (this.state.timeLineData[0]) !== 'undefined' &&
                this.state.timeLineData[0].hours.length > 0
                ? (
                  <>
                    {this.state.timeLineData.map(function (day, keyDay) {
                      if (keyDay < 4) {
                        return (
                          <ul className='hours-list' key={keyDay}>
                            {
                              day.hours.map(function (hour, keyHours) {
                                return (
                                  <li
                                    tabIndex="0"
                                    role="button"
                                    className={'hours-list--item ' +
                                      (hour.isHappy != 'false' ? 'special-hour ' : '') +
                                      (hour.time == 'false' ? 'hour-full ' : '')}
                                    data-deal={(hour.isHappy != 'false' ? hour.isHappy : '')}
                                    key={keyHours}
                                    ref={keyDay + '-' + keyHours}
                                    onClick={() => this.handleTimeChoice(day, keyDay, hour, keyHours)}
                                    onKeyDown={(e) => this.handleKeyDown(e, day, keyDay, hour, keyHours)}
                                  >
                                    <span className={`item-time ${(this.props.store.booking.hour == hour.time && this.props.store.dealer.geoID == this.props.dealerGeoId && this.props.store.booking.date == day.dayDate ? 'selected' : '')}`}> {(hour.time != 'false' ? hour.time : '')}</span>

                                  </li>
                                )
                              }.bind(this))
                            }

                          </ul>
                        )
                      }
                    }.bind(this))}
                  </>

                ) : <h3 className='hours-empty' dangerouslySetInnerHTML={{ __html: (CONSTANTS.LABELS.multislots_noslots) }}></h3>)}

            </div>
            : <div className='dataLoading'><img src={(window.siteConfig.currentBrand == 'P' ? loadingIconAP : (window.siteConfig.currentBrand == 'C' ? loadingIconAC : (window.siteConfig.currentBrand == 'D' ? loadingIconDS : loadingIconOV)))} /> </div>)}
        </div>
      </>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TimeLineCalendar)
